/* eslint-disable camelcase */
import { createSelector } from 'reselect';

export default createSelector(
  (state) => state.stores.payload,
  (payload) => {
    const { aggregations } = payload;

    if (!aggregations || !aggregations.results || !aggregations.results.buckets) return [];

    return aggregations.results.buckets.map((store) => ({
      key: store.key,
      name: store.key,
      itemTypes: [...store.item_type.buckets],
      orderTypes: [...store.order_type.buckets],
    }));
  },
);
